import { gql } from "generated-graphql";

export const NEWLY_NOT_REPORTING_FACILITIES_QUERY = gql(`
  query NewlyNotReportingFacilities(
    $reportingYear: Int
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    newlyNotReportingFacilities(
      reportingYear: $reportingYear
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      items {
        facilityId
        facilityName
        tenantId
        tenantName
        state
        notReportingReason
        encampStatusCurrentYear
        encampStatusPreviousYear
        currentYearReportId
        previousYearReportId
        hasNewlyNotReportingReport
        newlyNotReportingReportId
      }
      count
    }
  }
`);
